import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {LocalesActions} from '../store';
import {LocalesSelectors} from '../store/selectors';

@Injectable()
export class LocalesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadLocalesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadLocalesDone() {

    return this.store.pipe(
      select(LocalesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(LocalesActions.ReadLocales());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
